export default __webpack_public_path__ + "static/7-772bbec31b821821f8b45cbbef71afc6.webp";